import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function InscricaoPage() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    whatsapp: '',
    cidade: '',
    estado: '',
    objetivo: '',
    cpf: '',
    pagamento: 'parcelado'
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d65kiqbejqjf01jv4i5g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          whatsapp: '',
          cidade: '',
          estado: '',
          objetivo: '',
          cpf: '',
          pagamento: 'parcelado'
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <>
      <Navbar />
      <main className="pt-32 pb-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="font-display text-5xl lg:text-6xl font-bold text-purple-900 mb-6">
              Garanta seu acesso ao Eu Lidero
            </h1>
            <p className="text-xl text-gray-700 max-w-2xl mx-auto">
              Preencha o formulário abaixo e nossa equipe entrará em contato para finalizar sua inscrição
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-xl p-10 mb-12">
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-purple-900 mb-4">O que está incluído:</h2>
              <ul className="space-y-3">
                {[
                  '10 encontros ao vivo de 4 horas cada',
                  'Acesso ilimitado às gravações',
                  'Ferramentas práticas exclusivas',
                  'Suporte via WhatsApp',
                  'Certificado de conclusão',
                  'Comunidade exclusiva de mulheres líderes'
                ].map((item, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-gold-500 text-xl"></i>
                    </div>
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-purple-50 rounded-2xl p-6 mb-8">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-600 mb-1">Investimento</p>
                  <p className="text-3xl font-bold text-purple-900">12x R$294</p>
                  <p className="text-sm text-gray-600">ou R$2.890 à vista</p>
                </div>
                <div className="text-right">
                  <div className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-bold">
                    Economize R$638 no à vista
                  </div>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit} data-readdy-form id="inscricao-form">
              <div className="space-y-6">
                <div>
                  <label htmlFor="nome" className="block text-sm font-semibold text-gray-700 mb-2">
                    Nome completo *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    required
                    value={formData.nome}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                      E-mail *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm"
                    />
                  </div>

                  <div>
                    <label htmlFor="whatsapp" className="block text-sm font-semibold text-gray-700 mb-2">
                      WhatsApp *
                    </label>
                    <input
                      type="tel"
                      id="whatsapp"
                      name="whatsapp"
                      required
                      value={formData.whatsapp}
                      onChange={handleChange}
                      placeholder="(11) 99999-9999"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="cidade" className="block text-sm font-semibold text-gray-700 mb-2">
                      Cidade *
                    </label>
                    <input
                      type="text"
                      id="cidade"
                      name="cidade"
                      required
                      value={formData.cidade}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm"
                    />
                  </div>

                  <div>
                    <label htmlFor="estado" className="block text-sm font-semibold text-gray-700 mb-2">
                      Estado *
                    </label>
                    <input
                      type="text"
                      id="estado"
                      name="estado"
                      required
                      value={formData.estado}
                      onChange={handleChange}
                      placeholder="SP"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="objetivo" className="block text-sm font-semibold text-gray-700 mb-2">
                    Qual seu principal objetivo com o programa? *
                  </label>
                  <textarea
                    id="objetivo"
                    name="objetivo"
                    required
                    value={formData.objetivo}
                    onChange={handleChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm resize-none"
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
                </div>

                <div>
                  <label htmlFor="cpf" className="block text-sm font-semibold text-gray-700 mb-2">
                    CPF (opcional)
                  </label>
                  <input
                    type="text"
                    id="cpf"
                    name="cpf"
                    value={formData.cpf}
                    onChange={handleChange}
                    placeholder="000.000.000-00"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-3">
                    Forma de pagamento preferida *
                  </label>
                  <div className="space-y-3">
                    <label className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="radio"
                        name="pagamento"
                        value="parcelado"
                        checked={formData.pagamento === 'parcelado'}
                        onChange={handleChange}
                        className="w-5 h-5 text-purple-600 focus:ring-purple-500"
                      />
                      <span className="text-gray-700">12x R$294 (Total: R$3.528)</span>
                    </label>
                    <label className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="radio"
                        name="pagamento"
                        value="avista"
                        checked={formData.pagamento === 'avista'}
                        onChange={handleChange}
                        className="w-5 h-5 text-purple-600 focus:ring-purple-500"
                      />
                      <span className="text-gray-700">R$2.890 à vista (Economize R$638)</span>
                    </label>
                  </div>
                </div>

                {submitStatus === 'success' && (
                  <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                    <p className="text-green-700 font-medium">
                      ✓ Inscrição enviada com sucesso! Nossa equipe entrará em contato em breve.
                    </p>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <p className="text-red-700 font-medium">
                      Erro ao enviar inscrição. Por favor, tente novamente.
                    </p>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-gold-500 text-purple-900 py-5 rounded-full text-lg font-bold hover:bg-gold-400 transition-all hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? 'Enviando...' : 'Confirmar inscrição'}
                </button>
              </div>
            </form>
          </div>

          <div className="text-center">
            <p className="text-gray-600 mb-4">Dúvidas? Fale com nossa equipe</p>
            <a
              href="https://wa.me/5511999999999"
              className="inline-flex items-center space-x-2 text-purple-600 hover:text-purple-700 transition-colors font-semibold"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              <span>(11) 99999-9999</span>
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
